import Contact, { IContactContent } from './blocks/Contact'
import HowItWorks, { IHowItWorksContent } from './blocks/HowItWorks'
import Faq, { IFaqContent } from './blocks/Faq'
import TeamGrid, { ITeamGridContent } from './blocks/TeamGrid'
import FourUpHighlights, { I4UpHighlightsContent } from './blocks/4UpHighlights'
import ThreeUpHighlightCards, {
  I3UpHighlightCardsContent,
} from './blocks/3UpHighlightCards'
import Comparison, { IComparisonContent } from './blocks/Comparison'
import Features, { IFeaturesContent } from './blocks/Features'
import Locations, { ILocationsContent } from './blocks/Locations'
import Video, { IVideoContent } from './blocks/Video'
import Calculator, { ICalculatorContent } from './blocks/Calculator'
import ImageTextSplitCta, {
  IImageTextSplitCtaContent,
} from './blocks/ImageTextSplitCta'
import VideoGrid, { IVideoGridContent } from './blocks/VideoGrid'
import FeaturedHomes, { IFeaturedHomesContent } from './blocks/FeaturedHomes'
import HighlightsImageSplit, {
  IHighlightsImageSplitContent,
} from './blocks/HightlightsImageSplit'
import PressCards from './blocks/PressCards'
import CustomerValueCards from './blocks/CustomerValueCards'

type Block3UpHighlightCards = I3UpHighlightCardsContent & {
  __typename: 'Block3UpHighlightCards'
  sys: {
    id: string
  }
}

type Block4UpHighlights = I4UpHighlightsContent & {
  __typename: 'Block4UpHighlights'
  sys: {
    id: string
  }
}

type BlockCalculator = ICalculatorContent & {
  __typename: 'BlockCalculator'
  sys: {
    id: string
  }
}

type BlockComparison = IComparisonContent & {
  __typename: 'BlockComparison'
  sys: {
    id: string
  }
}

type BlockContact = IContactContent & {
  __typename: 'BlockContact'
  sys: {
    id: string
  }
}

type BlockFaq = IFaqContent & {
  __typename: 'BlockFaq'
  sys: {
    id: string
  }
}

type BlockFeatures = IFeaturesContent & {
  __typename: 'BlockFeatures'
  sys: {
    id: string
  }
}

type BlockHowItWorks = IHowItWorksContent & {
  __typename: 'BlockHowItWorks'
  sys: {
    id: string
  }
}

type BlockImageTextSplitCta = IImageTextSplitCtaContent & {
  __typename: 'BlockImageTextSplitCta'
  sys: {
    id: string
  }
}

type BlockLocations = ILocationsContent & {
  __typename: 'BlockLocations'
  sys: {
    id: string
  }
}

type BlockVideo = IVideoContent & {
  __typename: 'BlockVideo'
  sys: {
    id: string
  }
}

type BlockVideoGrid = IVideoGridContent & {
  __typename: 'BlockVideoGrid'
  sys: {
    id: string
  }
}

type BlockTeamGrid = ITeamGridContent & {
  __typename: 'BlockTeamGrid'
  sys: {
    id: string
  }
}

type BlockFeaturedHomes = IFeaturedHomesContent & {
  __typename: 'BlockFeaturedHomes'
  sys: {
    id: string
  }
}

type BlockHighlightsImageSplit = IHighlightsImageSplitContent & {
  __typename: 'BlockHighlightsImageSplit'
  sys: {
    id: string
  }
}

export type BlockMetadata = {
  trackingPosition: number
}

export type IPageBlock =
  | Block3UpHighlightCards
  | Block4UpHighlights
  | BlockCalculator
  | BlockComparison
  | BlockContact
  | BlockFaq
  | BlockFeatures
  | BlockHowItWorks
  | BlockImageTextSplitCta
  | BlockLocations
  | BlockTeamGrid
  | BlockVideo
  | BlockVideoGrid
  | BlockFeaturedHomes
  | BlockHighlightsImageSplit

interface IPageBlocksProps {
  blocks?: IPageBlock[]
  pressCards: Array<any>
  customerValueCards: Array<any>
  homeServiceCard: any
}

const PageBlocks = (props: IPageBlocksProps) => {
  const blocks = (props.blocks ?? []).map(
    ({ __typename: type, sys, ...content }: IPageBlock, i) => {
      const trackingPosition = i + 2 // block position on page, accounting for zero-indexing & hero

      switch (type) {
        case 'Block3UpHighlightCards':
          return (
            <ThreeUpHighlightCards
              key={sys.id}
              content={content as I3UpHighlightCardsContent}
            />
          )

        case 'Block4UpHighlights':
          return (
            <FourUpHighlights
              key={sys.id}
              content={content as I4UpHighlightsContent}
            />
          )

        case 'BlockCalculator':
          return (
            <Calculator key={sys.id} content={content as ICalculatorContent} />
          )

        case 'BlockComparison':
          return (
            <Comparison key={sys.id} content={content as IComparisonContent} />
          )

        case 'BlockContact':
          return <Contact key={sys.id} content={content as IContactContent} />

        case 'BlockFaq':
          return <Faq key={sys.id} content={content as IFaqContent} />

        case 'BlockFeatures':
          return (
            <Features
              key={sys.id}
              content={content as IFeaturesContent}
              trackingPosition={trackingPosition}
            />
          )

        case 'BlockFeaturedHomes':
          return (
            <FeaturedHomes
              key={sys.id}
              content={content as IFeaturedHomesContent}
              trackingPosition={trackingPosition}
            />
          )

        case 'BlockHighlightsImageSplit':
          return (
            <HighlightsImageSplit
              key={sys.id}
              content={content as IHighlightsImageSplitContent}
            />
          )

        case 'BlockHowItWorks':
          return (
            <HowItWorks key={sys.id} content={content as IHowItWorksContent} />
          )

        case 'BlockImageTextSplitCta':
          return (
            <ImageTextSplitCta
              key={sys.id}
              content={content as IImageTextSplitCtaContent}
              trackingPosition={trackingPosition}
            />
          )

        case 'BlockLocations':
          return (
            <Locations
              key={sys.id}
              content={content as ILocationsContent}
              trackingPosition={trackingPosition}
            />
          )

        case 'BlockVideo':
          return <Video key={sys.id} content={content as IVideoContent} />

        case 'BlockVideoGrid':
          return (
            <VideoGrid key={sys.id} content={content as IVideoGridContent} />
          )

        case 'BlockTeamGrid':
          return <TeamGrid key={sys.id} content={content as ITeamGridContent} />
      }
    }
  )

  blocks.splice(1, 0, <PressCards cards={props.pressCards} key="press" />)
  blocks.splice(
    2,
    0,
    <CustomerValueCards key="customer-value" cards={props.customerValueCards} />
  )
  blocks.splice(3, 1)

  // Only insert the home care card when the entry actually resolved: an
  // unpublished block reaches here as null (get-home-content optional-chains
  // it) and HomeCareCard dereferences card.image.url. This is the last splice
  // and nothing below it reads the array, so gating it cannot shift the index
  // any earlier splice used - each of those ran already, against array state
  // fixed entirely by the splices before it.
  if (props.homeServiceCard) {
    blocks.splice(
      -1,
      0,
      <HomeCareCard key="home-card" card={props.homeServiceCard} />
    )
  }

  return <>{blocks}</>
}

export default PageBlocks

import Image from 'next/image'

interface HomeCareCardProps {
  card: {
    title: string
    body: string
    buttonText: string
    buttonUrl: string
    image: {
      url: string
    }
  } | null
}

const HomeCareCard: React.FC<HomeCareCardProps> = ({ card }) => {
  if (!card) return null

  return (
    <div className="grid grid-rows-2 rounded-lg bg-white shadow-lg sm:grid-cols-2 sm:grid-rows-1">
      {/* Image Section */}
      <div className="relative">
        <Image
          src={card.image.url}
          alt="Home Care Service"
          layout="fill"
          objectFit="cover"
          className="rounded-l-none rounded-t-lg sm:rounded-l-lg sm:rounded-t-none"
        />
      </div>

      {/* Text Section */}
      <div className="flex flex-col items-stretch justify-center p-[30px] sm:p-[80px]">
        <h2 className="mb-4 text-center text-[32px] font-[600] leading-[40px]">
          {card.title}
        </h2>

        {/* Split description on \n\n and map to <p> elements */}
        <div className="text-base mb-6 mt-[15px] flex flex-col gap-[20px] space-y-4">
          {card.body.split('\n').map((paragraph, index) => (
            <p key={index} className="font-[400] leading-[25px] text-grey-8">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="mt-[40px] flex justify-center">
          <a
            href={card.buttonUrl}
            className="hover:bg-green-700 w-full rounded-sm bg-teal-4 px-[16px] py-[7px] text-center text-white transition sm:w-auto"
          >
            {card.buttonText}
          </a>
        </div>
      </div>
    </div>
  )
}
